import { render } from "./ItemReport.vue?vue&type=template&id=54ecb7a9"
import script from "./ItemReport.vue?vue&type=script&lang=js"
export * from "./ItemReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__